import { render, staticRenderFns } from "./HabilitationTable.vue?vue&type=template&id=44c78fa0"
import script from "./HabilitationTable.vue?vue&type=script&lang=js"
export * from "./HabilitationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports